/**
 * Created by Ivan on 24.05.2025
 */

const MagnetTutorial = function () {
    return new TutorialScenario(MagnetTutorial.NAME, {
        listSteps: () => [
            TileGameTutorialHelper.createPlayCardStep(MagnetTutorial.CONFIG)
        ],

        onStart: function () {
            Game.currentGame.shownTutorials.push(MagnetTutorial.NAME);
            Game.currentGame.hand.setCards(MagnetTutorial.CONFIG.handValues);
        },

        isAvailable: () => TileGameTutorialHelper.isAvailable(MagnetTutorial.NAME)
    });
};

MagnetTutorial.NAME = "magnet";
MagnetTutorial.CONFIG = {
    handValues: ["3"],
    force: "MagnetTutorialMessage"
};
